import React from "react";
import { BRAND } from "../lib/data";

/**
 * Logo — renders the brokerage logo from the single BRAND config.
 * Swap the logo/name for any demo by editing BRAND in lib/data.ts.
 *
 * variant="primary"  → 1-line logo (default, best for bars/headers)
 * variant="stacked"  → 2-line logo (larger brand moments)
 */
export function Logo({
  variant = "primary",
  className = "h-7 w-auto"
}: {
  variant?: "primary" | "stacked";
  className?: string;
}) {
  const src = variant === "stacked" ? BRAND.logo.stacked : BRAND.logo.primary;
  return <img src={src} alt={BRAND.name} className={`${className} object-contain object-left`} draggable={false} data-id="element-367" data-mp="rr5zsg5369w1" />;
}